// extracted by css-extract-rspack-plugin
export default {"selectPanelContainer":"PropertyValueField-module__selectPanelContainer__pwQBK","validationFeedback":"PropertyValueField-module__validationFeedback__jOYIM"};